export const PENDING_LEADS = "PENDING_LEADS";
export const SUCCESS_LEADS = "SUCCESS_LEADS";
export const ERROR_LEADS = "ERROR_LEADS";

export const PENDING_ORDER_LIST = "PENDING_ORDER_LIST";
export const SUCCESS_ORDER_LIST = "SUCCESS_ORDER_LIST";
export const ERROR_ORDER_LIST = "ERROR_SUCCESS_ORDER_LIST";

export const PENDING_RANNKAAR_LIST = "PENDING_RANNKAAR_LIST";
export const SUCCESS_RANNKAAR_LIST = "SUCCESS_RANNKAAR_LIST";
export const ERROR_RANNKAAR_LIST = "ERROR_SUCCESS_RANNKAAR_LIST";

export const PENDING_PREBOOK_LIST = "PENDING_PREBOOK_LIST";
export const SUCCESS_PREBOOK_LIST = "SUCCESS_PREBOOK_LIST";
export const ERROR_PREBOOK_LIST = "ERROR_PREBOOK_LIST";

export const PENDING_ENQUIRY_LIST = "PENDING_ENQUIRY_LIST";
export const SUCCESS_ENQUIRY_LIST = "SUCCESS_ENQUIRY_LIST";
export const ERROR_ENQUIRY_LIST = "ERROR_ENQUIRY_LIST";

export const PENDING_PREBOOK_DETAILS = "PENDING_PREBOOK_DETAILS";
export const SUCCESS_PREBOOK_DETAILS = "SUCCESS_PREBOOK_DETAILS";
export const ERROR_PREBOOK_DETAILS = "ERROR_PREBOOK_DETAILS";

export const PENDING_UPDATE_PREBOOK_DETAILS = "PENDING_UPDATE_PREBOOK_DETAILS";
export const SUCCESS_UPDATE_PREBOOK_DETAILS = "SUCCESS_UPDATE_PREBOOK_DETAILS";
export const ERROR_UPDATE_PREBOOK_DETAILS = "ERROR_UPDATE_PREBOOK_DETAILS";

export const PENDING_CALLBACK_LIST = "PENDING_CALLBACK_LIST";
export const SUCCESS_CALLBACK_LIST = "SUCCESS_CALLBACK_LIST";
export const ERROR_CALLBACK_LIST = "ERROR_CALLBACK_LIST";

export const PENDING_APPOINTMENT_LIST = "PENDING_APPOINTMENT_LIST";
export const SUCCESS_APPOINTMENT_LIST = "SUCCESS_APPOINTMENT_LIST";
export const ERROR_APPOINTMENT_LIST = "ERROR_APPOINTMENT_LIST";

export const PENDING_STORE_MASTER_LIST = "PENDING_STORE_MASTER_LIST";
export const SUCCESS_STORE_MASTER_LIST = "SUCCESS_STORE_MASTER_LIST";
export const ERROR_STORE_MASTER_LIST = "ERROR_STORE_MASTER_LIST";

export const PENDING_CITY_LIST = "PENDING_CITY_LIST";
export const SUCCESS_CITY_LIST = "SUCCESS_CITY_LIST";
export const ERROR_CITY_LIST = "ERROR_CITY_LIST";

export const PENDING_STORE_LIST = "PENDING_STORE_LIST";
export const SUCCESS_STORE_LIST = "SUCCESS_STORE_LIST";
export const ERROR_STORE_LIST = "ERROR_STORE_LIST";

export const PENDING_STORE_MASTER_BY_ID = "PENDING_STORE_MASTER_BY_ID";
export const SUCCESS_STORE_MASTER_BY_ID = "SUCCESS_STORE_MASTER_BY_ID";
export const ERROR_STORE_MASTER_BY_ID = "ERROR_STORE_MASTER_BY_ID";

export const PENDING_UPDATE_STORE_MASTER_DATA = "PENDING_UPDATE_STORE_MASTER_DATA";
export const SUCCESS_UPDATE_STORE_MASTER_DATA = "UPDATE_STORE_MASTER_DATA";
export const ERROR_UPDATE_STORE_MASTER_DATA = "ERROR_UPDATE_STORE_MASTER_DATA";

export const PENDING_ADD_STORE_MASTER_DATA = "PENDING_ADD_STORE_MASTER_DATA";
export const SUCCESS_ADD_STORE_MASTER_DATA = "SUCCESS_ADD_STORE_MASTER_DATA";
export const ERROR_ADD_STORE_MASTER_DATA = "ERROR_ADD_STORE_MASTER_DATA";

export const PENDING_ADD_GOLD_RATE = "PENDING_ADD_GOLD_RATE";
export const SUCCESS_ADD_GOLD_RATE = "SUCCESS_ADD_GOLD_RATE";
export const ERROR_ADD_GOLD_RATE = "ERROR_ADD_GOLD_RATE";

export const PENDING_GET_GOLD_RATE = "PENDING_GET_GOLD_RATE";
export const SUCCESS_GET_GOLD_RATE = "SUCCESS_GET_GOLD_RATE";
export const ERROR_GET_GOLD_RATE = "ERROR_GET_GOLD_RATE";

export const PENDING_GET_IS_USER_LIVE = "PENDING_GET_IS_USER_LIVE";
export const SUCCESS_GET_IS_USER_LIVE = "SUCCESS_GET_IS_USER_LIVE";
export const ERROR_GET_IS_USER_LIVE = "ERROR_GET_IS_USER_LIVE";

export const PENDING_UPDATE_BULK_STORE_MASTER_DATA = "PENDING_UPDATE_BULK_STORE_MASTER_DATA";
export const SUCCESS_UPDATE_BULK_STORE_MASTER_DATA = "SUCCESS_UPDATE_BULK_STORE_MASTER_DATA";
export const ERROR_UPDATE_BULK_STORE_MASTER_DATA = "ERROR_UPDATE_BULK_STORE_MASTER_DATA";

export const PENDING_EVENT_CAMPAIGN_LIST = "PENDING_EVENT_CAMPAIGN_LIST";
export const SUCCESS_EVENT_CAMPAIGN_LIST = "SUCCESS_EVENT_CAMPAIGN_LIST";
export const ERROR_EVENT_CAMPAIGN_LIST = "ERROR_EVENT_CAMPAIGN_LIST";

export const PENDING_USERS_LIST = "PENDING_USERS_LIST";
export const SUCCESS_USERS_LIST = "SUCCESS_USERS_LIST";
export const ERROR_USERS_LIST = "ERROR_USERS_LIST";

export const PENDING_CHECK_EMAIL = "PENDING_CHECK_EMAIL";
export const SUCCESS_CHECK_EMAIL = "SUCCESS_CHECK_EMAIL";
export const ERROR_CHECK_EMAIL = "ERROR_CHECK_EMAIL";

export const PENDING_ADD_USER = "PENDING_ADD_USER";
export const SUCCESS_ADD_USER = "SUCCESS_ADD_USER";
export const ERROR_ADD_USER = "ERROR_ADD_USER";

export const PENDING_UPDATE_USER = "PENDING_UPDATE_USER";
export const SUCCESS_UPDATE_USER = "SUCCESS_UPDATE_USER";
export const ERROR_UPDATE_USER = "ERROR_UPDATE_USER";

export const PENDING_USER_BY_ID = "PENDING_USER_BY_ID";
export const SUCCESS_USER_BY_ID = "SUCCESS_USER_BY_ID";
export const ERROR_USER_BY_ID = "ERROR__USER_BY_ID";

export const PENDING_DELETE_USER = "PENDING_DELETE_USER";
export const SUCCESS_DELETE_USER = "SUCCESS_DELETE_USER";
export const ERROR_DELETE_USER = "ERROR_DELETE_USER";

export const PENDING_STORE_MASTER_LOGIN_LIST = "PENDING_STORE_MASTER_LOGIN_LIST";
export const SUCCESS_STORE_MASTER_LOGIN_LIST = "SUCCESS_STORE_MASTER_LOGIN_LIST";
export const ERROR_STORE_MASTER_LOGIN_LIST = "ERROR_STORE_MASTER_LOGIN_LIST";

export const PENDING_NSO_CAMPAIGN_LIST = "PENDING_NSO_CAMPAIGN_LIST";
export const SUCCESS_NSO_CAMPAIGN_LIST = "SUCCESS_NSO_CAMPAIGN_LIST";
export const ERROR_NSO_CAMPAIGN_LIST = "ERROR_NSO_CAMPAIGN_LIST";

export const PENDING_FEEDBACK_LIST = "PENDING_FEEDBACK_LIST";
export const SUCCESS_FEEDBACK_LIST = "SUCCESS_FEEDBACK_LIST";
export const ERROR_FEEDBACK_LIST = "ERROR_FEEDBACK_LIST";

export const PENDING_LIKE_PRODUCT_LIST = "PENDING_LIKE_PRODUCT_LIST";
export const SUCCESS_LIKE_PRODUCT_LIST = "SUCCESS_LIKE_PRODUCT_LIST";
export const ERROR_LIKE_PRODUCT_LIST = "ERROR_LIKE_PRODUCT_LIST";

export const PENDING_SALE_LIST = "PENDING_SALE_LIST";
export const SUCCESS_SALE_LIST = "SUCCESS_SALE_LIST";
export const ERROR_SALE_LIST = "ERROR_SALE_LIST";

export const PENDING_CUSTOMER_CART_DETAILS = "PENDING_CUSTOMER_CART_DETAILS";
export const SUCCESS_CUSTOMER_CART_DETAILS = "SUCCESS_CUSTOMER_CART_DETAILS";
export const ERROR_CUSTOMER_CART_DETAILS = "ERROR_CUSTOMER_CART_DETAILS";

export const PENDING_TRY_ON_VIDEO_ASSISTANCE_LIST = "PENDING_TRY_ON_VIDEO_ASSISTANCE_LIST";
export const SUCCESS_TRY_ON_VIDEO_ASSISTANCE_LIST = "SUCCESS_TRY_ON_VIDEO_ASSISTANCE_LIST";
export const ERROR_TRY_ON_VIDEO_ASSISTANCE_LIST = "ERROR_TRY_ON_VIDEO_ASSISTANCE_LIST";

export const PENDING_MAKE_TO_ORDER_JEWELS_LIST = "PENDING_MAKE_TO_ORDER_JEWELS_LIST";
export const SUCCESS_MAKE_TO_ORDER_JEWELS_LIST = "SUCCESS_MAKE_TO_ORDER_JEWELS_LIST";
export const ERROR_MAKE_TO_ORDER_JEWELS_LIST = "ERROR_MAKE_TO_ORDER_JEWELS_LIST";

export const PENDING_WISH_LIST = "PENDING_WISH_LIST";
export const SUCCESS_WISH_LIST = "SUCCESS_WISH_LIST";
export const ERROR_WISH_LIST = "ERROR_WISH_LIST";

export const PENDING_QR_CODE_LIST = "PENDING_QR_CODE_LIST";
export const SUCCESS_QR_CODE_LIST = "SUCCESS_QR_CODE_LIST";
export const ERROR_QR_CODE_LIST = "ERROR_QR_CODE_LIST";

export const PENDING_DELETE_QR_CODE = "PENDING_DELETE_QR_CODE";
export const SUCCESS_DELETE_QR_CODE = "SUCCESS_DELETE_QR_CODE";
export const ERROR_DELETE_QR_CODE = "ERROR_DELETE_QR_CODE";

export const PENDING_SCAN_BAR_CODE_LIST = "PENDING_SCAN_BAR_CODE_LIST";
export const SUCCESS_SCAN_BAR_CODE_LIST = "SUCCESS_SCAN_BAR_CODE_LIST";
export const ERROR_SCAN_BAR_CODE_LIST = "ERROR_SCAN_BAR_CODE_LIST";

export const PENDING_UPDATE_BULK_BARCODE = "PENDING_UPDATE_BULK_BARCODE";
export const SUCCESS_UPDATE_BULK_BARCODE = "SUCCESS_UPDATE_BULK_BARCODE";
export const ERROR_UPDATE_BULK_BARCODE = "ERROR_UPDATE_BULK_BARCODE";

export const PENDING_FEEDBACK_JH_LIST = "PENDING_FEEDBACK_JH_LIST";
export const SUCCESS_FEEDBACK_JH_LIST = "SUCCESS_FEEDBACK_JH_LIST";
export const ERROR_FEEDBACK_JH_LIST = "ERROR_FEEDBACK_JH_LIST";

export const PENDING_MAKE_TO_ORDER_JH_LIST = "PENDING_MAKE_TO_ORDER_JH_LIST";
export const SUCCESS_MAKE_TO_ORDER_JH_LIST = "SUCCESS_MAKE_TO_ORDER_JH_LIST";
export const ERROR_MAKE_TO_ORDER_JH_LIST = "ERROR_MAKE_TO_ORDER_JH_LIST";

export const PENDING_FESTIVE_FEEDBACK_LIST = "PENDING_FESTIVE_FEEDBACK_LIST";
export const SUCCESS_FESTIVE_FEEDBACK_LIST = "SUCCESS_FESTIVE_FEEDBACK_LIST";
export const ERROR_FESTIVE_FEEDBACK_LIST = "ERROR_FESTIVE_FEEDBACK_LIST";

export const PENDING_FESTIVE_AD_LIST = "PENDING_FESTIVE_AD_LIST";
export const SUCCESS_FESTIVE_AD_LIST = "SUCCESS_FESTIVE_AD_LIST";
export const ERROR_FESTIVE_AD_LIST = "ERROR_FESTIVE_AD_LIST";

export const PENDING_NPS_FEEDBACK_LIST = "PENDING_NPS_FEEDBACK_LIST";
export const SUCCESS_NPS_FEEDBACK_LIST = "SUCCESS_NPS_FEEDBACK_LIST";
export const ERROR_NPS_FEEDBACK_LIST = "ERROR_NPS_FEEDBACK_LIST";

export const PENDING_ADD_CALL_SLOT = "PENDING_ADD_CALL_SLOT";
export const SUCCESS_ADD_CALL_SLOT = "SUCCESS_ADD_CALL_SLOT";
export const ERROR_ADD_CALL_SLOT = "ERROR_ADD_CALL_SLOT";

export const PENDING_CTA_LIST = "PENDING_CTA_LIST";
export const SUCCESS_CTA_LIST = "SUCCESS_CTA_LIST";
export const ERROR_CTA_LIST = "ERROR_CTA_LIST";